export default __webpack_public_path__ + "static/media/Dayananda.6e44bb8b.png";